var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rcc-select',_vm._g(_vm._b({attrs:{"hide-details":"","menu-class":"inline-control"}},'rcc-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }